import NotificationCard from "./NotificationCard";

export default NotificationCard;
